import { enableTooltip, enablePopover } from 'bs'
document.addEventListener('turbo:load', enableTooltip)
document.addEventListener('turbo:load', enablePopover)
document.addEventListener('turbo:before-stream-render', (event) => {
  const render = event.detail.render
  event.detail.render = async (streamElement) => {
    await render(streamElement)
    enableTooltip()
    enablePopover()
  }
})
